import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { LocalstorageService } from "../../shared";

@Injectable({
	providedIn: "root",
})
export class SchoolselectorService {
	constructor(private localService: LocalstorageService) {}

	SchoolChangeSubject = new BehaviorSubject<any>("");
	// SchoolChangeObservable = this.SchoolChangeSubject.asObservable();
	RefreshSubject = new BehaviorSubject<any>("");

	//
	// Called from Person Selector
	//
	ManuallyUpdateSchool(School) {
		this.localService.setItem("SchoolSelector_School", School);

		this.SchoolChanged(School);
	}

	//
	// Call to change data
	//
	SchoolChanged(data: any) {
		this.SchoolChangeSubject.next(data);
	}

	//
	// Subscribe to to get data
	//
	onSchoolChanged(): Observable<any> {
		return this.SchoolChangeSubject.asObservable();
	}

	onRefreshChanged(): Observable<any> {
		return this.RefreshSubject.asObservable();
	}

	SchoolRefresh(data: any) {
		this.RefreshSubject.next(data);
	}
}
